import React from 'react';

// Controlled fields shared by the template minter and media mint settings.
export default function NFTMetadataFields({
    name = '', description = '', attributes = [], externalUrl,
    onChange, disabled = false,
}) {
    const updateAttribute = (index, field, value) => onChange({
        attributes: attributes.map((attribute, i) => i === index ? { ...attribute, [field]: value } : attribute),
    });
    return <fieldset disabled={disabled} style={{ border: 0, padding: 0, minWidth: 0 }}>
        <label>NFT Name<input className="muulti-input" placeholder="NFT Name" maxLength={100} value={name}
            onChange={event => onChange({ name: event.target.value })} /></label>
        <label>NFT Description<textarea className="muulti-textarea" placeholder="NFT Description" maxLength={4000}
            value={description} onChange={event => onChange({ description: event.target.value })} /></label>
        {externalUrl !== undefined && <label>External link (optional)<input className="muulti-input" type="url"
            value={externalUrl} maxLength={2048} onChange={event => onChange({ externalUrl: event.target.value })} /></label>}
        <div className="attributes-list">
            <h4>Attributes</h4>
            {attributes.map((attribute, index) => <div key={index} className="attribute-row">
                <input className="muulti-input" placeholder="Attribute Name" aria-label={'Attribute name ' + (index + 1)}
                    maxLength={128} value={attribute.name || attribute.trait_type || ''}
                    onChange={event => updateAttribute(index, 'name', event.target.value)} />
                <input className="muulti-input" placeholder="Attribute Value" aria-label={'Attribute value ' + (index + 1)}
                    maxLength={2048} value={String(attribute.value ?? '')}
                    onChange={event => updateAttribute(index, 'value', event.target.value)} />
                <button type="button" className="muulti-button cancel-button"
                    onClick={() => onChange({ attributes: attributes.filter((_, i) => i !== index) })}>Remove</button>
            </div>)}
            <button type="button" className="muulti-button add-attribute-button" disabled={attributes.length >= 100}
                onClick={() => onChange({ attributes: [...attributes, { name: '', value: '' }] })}>Add Attribute</button>
        </div>
    </fieldset>;
}
